<ng-container *ngIf="model">
  <entity-icon [size]="'24px'" *ngIf="model.view.icon" [model]="model.view.icon" class="item-icon"></entity-icon>
  <result-title [model]="model.view.title" [selected]="selected" class="item-title" (invoke)="onInvoke($event)"> </result-title>
</ng-container>
